import React from 'react';
import { CTAButton } from './CTAButton';
export const ValorPercibido: React.FC = () => {
  const items = [{
    emoji: '📚',
    title: 'Biblioteca principal Disney',
    value: '$29.990',
    description: 'Más de 50 libros con 2.500+ páginas'
  }, {
    emoji: '🎁',
    title: 'Bonus exclusivos',
    value: '$14.990',
    description: 'Páginas extra de villanos, princesas y Pixar'
  }, {
    emoji: '📥',
    title: 'Descarga inmediata',
    value: '$5.000',
    description: 'Acceso instantáneo tras la compra'
  }, {
    emoji: '🖨️',
    title: 'Impresión ilimitada',
    value: '$10.000',
    description: 'Imprime todas las veces que quieras, para siempre'
  }];
  return <section className="py-8 px-4 bg-cream" data-id="element-217">
      <div className="max-w-2xl mx-auto" data-id="element-218">
        <div className="text-center mb-6" data-id="element-219">
          <h2 className="font-rounded font-bold text-[2rem] sm:text-4xl text-violet leading-tight" data-id="element-220">
            Todo lo que <span className="text-gold-dark" data-id="element-221">recibes hoy</span>
          </h2>
        </div>

        <div className="bg-white rounded-3xl border-2 border-gold/50 shadow-card overflow-hidden mb-5" data-id="element-222">
          <ul data-id="element-223">
            {items.map((item, idx) => <li key={idx} className={`flex items-start gap-3 px-5 py-4 ${idx !== items.length - 1 ? 'border-b-2 border-dashed border-cream-dark' : ''}`} data-id="element-224">
                <span className="text-3xl flex-shrink-0 leading-none" data-id="element-225">
                  {item.emoji}
                </span>
                <div className="flex-grow min-w-0" data-id="element-226">
                  <div className="flex items-start justify-between gap-2 mb-0.5" data-id="element-227">
                    <h3 className="font-rounded font-bold text-violet text-sm sm:text-base leading-tight" data-id="element-228">
                      {item.title}
                    </h3>
                    <span className="font-rounded font-bold text-violet text-sm whitespace-nowrap" data-id="element-229">
                      {item.value}
                    </span>
                  </div>
                  <p className="text-xs sm:text-sm text-textsoft font-semibold leading-snug" data-id="element-230">
                    {item.description}
                  </p>
                </div>
              </li>)}
          </ul>

          <div className="bg-cream-dark/70 px-5 py-4 border-t-[3px] border-gold" data-id="element-231">
            <div className="flex items-center justify-between mb-2" data-id="element-232">
              <span className="font-rounded font-bold text-violet text-sm sm:text-base" data-id="element-233">
                Valor real total:
              </span>
              <span className="font-rounded font-bold text-gray-400 line-through text-lg" data-id="element-234">
                $59.990
              </span>
            </div>
            <div className="flex items-center justify-between" data-id="element-235">
              <span className="font-rounded font-bold text-violet text-base sm:text-lg uppercase" data-id="element-236">
                Hoy pagas solo:
              </span>
              <span className="font-rounded font-bold text-violet text-3xl sm:text-4xl" data-id="element-237">
                $19.990
              </span>
            </div>
            <p className="text-center text-xs sm:text-sm font-bold text-brandgreen mt-2" data-id="element-238">
              🎉 Ahorras $40.000 (67% OFF)
            </p>
          </div>
        </div>

        <CTAButton data-id="element-239" />
      </div>
    </section>;
};